import { HTTPv2, Service } from '@/services/config'

class VehicleServiceV2 extends Service {
  path = 'veiculo'

  constructor() {
    super(HTTPv2)
  }

  async getVeiculo(params: any) {
    const httpResponse = await this.httpClient.get(`${this.path}/obterveiculo`, { params })
    return httpResponse
  }

  async getFrota(filters: any) {
    const httpResponse = await this.httpClient.get(`${this.path}/frota`, { params: filters })
    return httpResponse
  }
}
export const vehicleServiceV2 = new VehicleServiceV2()
